import React from "react";
import { message } from "antd";
import Button from "../../../shared/globalStyling/Button";
import { multiImageZipKey } from "../../../../core/utils/dataloading/multiImageZipKey";

const DownloadAdUnitButton = ({
  creativeKeys,
  disabled,
  label = "Download Selected Creative/s",
  onDownloadComplete,
}) => {
  const handleDownload = async () => {
    try {
      await multiImageZipKey(
        `Creatives (${creativeKeys.length} creative)`,
        creativeKeys
      );
      if (onDownloadComplete) onDownloadComplete();
      message.success(`Successfully prepared download for ${creativeKeys.length} creative(s)`);
    } catch (error) {
      message.error('Download failed. Please try again.');
    }
  };

  return (
    <Button
      type="primary"
      disabled={!creativeKeys || creativeKeys.length === 0 || disabled}
      onClick={handleDownload}
    >
      {label}
    </Button>
  );
};

export default DownloadAdUnitButton;
